import { useLocation } from 'react-router';

/**
 * react-router's per-navigation key, or null outside a router context (e.g. the CMS page
 * builder's live preview), mirroring the other `useSafe*` wrappers in this folder.
 *
 * The key changes on EVERY navigation, including a push to the URL already displayed — which
 * is the distinction a component needs to tell "the visitor navigated again" from "React
 * re-rendered me". Comparing the URL or its params cannot express that.
 */
export function useSafeLocationKey(): string | null {
  try {
    return useLocation().key;
  } catch {
    return null;
  }
}
